export const VIEWER_MIN_SCALE = 1;
export const VIEWER_MAX_SCALE = 4;

export function clampViewerScale(scale) {
  const numeric = Number(scale);
  if (!Number.isFinite(numeric)) return VIEWER_MIN_SCALE;
  return Math.min(VIEWER_MAX_SCALE, Math.max(VIEWER_MIN_SCALE, numeric));
}

export function pinchViewerScale(startScale, startDistance, distance) {
  if (!Number.isFinite(startDistance) || startDistance <= 0) return clampViewerScale(startScale);
  if (!Number.isFinite(distance) || distance <= 0) return clampViewerScale(startScale);
  return clampViewerScale(startScale * (distance / startDistance));
}

export function panViewer(scale, x, y, width, height) {
  const fitted = clampViewerScale(scale);
  if (fitted <= 1) return { scale: 1, x: 0, y: 0 };
  const limitX = Math.max(0, ((fitted - 1) * (Number(width) || 0)) / 2);
  const limitY = Math.max(0, ((fitted - 1) * (Number(height) || 0)) / 2);
  const nextX = Number.isFinite(x) ? x : 0;
  const nextY = Number.isFinite(y) ? y : 0;
  return {
    scale: fitted,
    x: Math.min(limitX, Math.max(-limitX, nextX)),
    y: Math.min(limitY, Math.max(-limitY, nextY)),
  };
}

export function viewerOrientationChanged(previous, next) {
  if (!previous || !next) return false;
  return Boolean(previous.landscape) !== Boolean(next.landscape);
}
